import { LATAM_COUNTRY_NAMES } from "../../features/countries/types";
import { GridRowId } from "@mui/x-data-grid";

export const LATAMCountries = Object.values(LATAM_COUNTRY_NAMES);

export type ConfirmAction = "save" | "delete";

export interface Row {
  id: string;
  password: string;
  email: string;
  name?: string;
  surname?: string;
  region_id: string;
  countries: string[];
  isAdmin: boolean;
  isActive: boolean;
  isNew?: boolean;
}

export type ToggleActionProps = (
  targetRowId: GridRowId,
  toggleProperty: "isActive" | "isAdmin"
) => () => void;

export type MultipleSelectField = "region_id" | "countries";
